// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__w5ZuM","inner":"Header_inner__2w5f3","subtitle":"Header_subtitle__M4E-p","logo":"Header_logo__4JLKS","search":"Header_search__1rhIN"};